module.exports = __webpack_public_path__ + "static/media/pin_civil_defense_vehicle.dbe56581.svg";